import { ScheduleEntryState, Task, Timestamp } from '@griply/types';
import { isSameDay } from 'date-fns';

import { getScheduleDayTarget } from './get-schedule-day-target';
import { getScheduleByDate } from './schedules';

export type GetTaskDayProgressOptions = {
  day: Timestamp;
  today: Timestamp;
};

export type TaskDayProgress = {
  value?: number;
  target?: number;
};

// `target` is per-day even for a frequency schedule (3x/week -> 1), never per-timeframe.
export const getTaskDayProgress = (
  task: Task,
  { day, today }: GetTaskDayProgressOptions,
): TaskDayProgress => {
  const schedule = getScheduleByDate(task.schedules, { date: day, today });

  if (!schedule) {
    return {};
  }

  const target = getScheduleDayTarget(schedule);

  const entry = schedule.entries.find(
    ({ date, state, value }) =>
      isSameDay(date, day) && state === ScheduleEntryState.Complete && !!value,
  );

  return { value: entry?.value ?? undefined, target };
};
